<mat-toolbar color="primary">
  <span id="møte-publiser-dialog-tittel">
    {{ "Send påminnelse om signering av '{filnavn}'"|translate: {filnavn: dokumentversjon().pdfFilnavn} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@if (laster()) {
  <mat-progress-bar mode="indeterminate"/>
}

@if (modus() == 'skjema') {
  <!-- ingen [formGroup] da siden kun inneholder én formControl -->
  <form (ngSubmit)="send()">
    <mat-dialog-content class="skjema">
      <tips>
        {{ 'En automatisk påminnelse blir sendt {dato} ({omAntallDager}), uavhengig av denne påminnelsen.'|translate: {dato: signatarer().nestePurringSendes |zoneddatetime, omAntallDager: purringSendesOmAntallDager()} }}
      </tips>

      <mat-form-field>
        <mat-label>{{ 'Skriv inn beskjed inkludert i påminnelse'|translate }}</mat-label>
        <riktekst-redigering [skjemakontroll]="beskjedKontroller" [gruppeId]="dokumentversjon().gruppeId"/>
      </mat-form-field>

      <h4>{{ 'Påminnelse sendes til'|translate }}</h4>
      <medlemmer-listevisning-kompakt [medlemmer]="harIkkeSignert()"/>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary" type="submit" cdkFocusInitial
              [disabled]="beskjedKontroller.invalid || lagrer()" [visSpinner]="lagrer()"
              spinnerTekst="{{'Sender...'|translate}}" data-testid="send">
        {{ 'Send påminnelse'|translate }}
      </button>
    </mat-dialog-actions>
  </form>

} @else {
  <mat-dialog-content class="kvittering e2e-kvittering">
    <p>{{ 'Påminnelse har blitt sendt til {antall} medlemmer'|translate: {antall: antallSendt()} }}</p>
    <melding-sendt-ikon/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
      <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
        {{ 'Lukk'|translate }}
      </button>
  </mat-dialog-actions>
}
